export const DVR_SNAPSHOTS_REQUEST = 'DVR_SNAPSHOTS/REQUEST';
export const DVR_SNAPSHOTS_SUCCESS = 'DVR_SNAPSHOTS/SUCCESS';
export const DVR_SNAPSHOTS_OFFLINE = 'DVR_SNAPSHOTS/OFFLINE';
export const DVR_SNAPSHOTS_FAILURE = 'DVR_SNAPSHOTS/FAILURE';
export const DVR_SNAPSHOTS_NOT_AVAILABLE = 'DVR_SNAPSHOTS/NOT_AVAILABLE';
export const DVR_SNAPSHOTS_CAROUSEL_OPENED = 'DVR_SNAPSHOTS/CAROUSEL_OPENED';
export const DVR_SNAPSHOTS_CAROUSEL_CLOSED = 'DVR_SNAPSHOTS/CAROUSEL_CLOSED';
